import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { map } from 'rxjs/operators';

@Injectable()
export class ComplaintsDropDownService {
  url = environment.configURI;
  private getCategoryList = '/complaints_drop_down/Category';
  private getTypeOfComplaintList = '/complaints_drop_down/ComplaintType';
  private getComplaintSourceList = '/complaints_drop_down/ComplaintSource';
  private getUsersList ='/getusersbyrole?role=resolutionManager';
  private getRequestList = '/complaints_drop_down/Request';
  private getResolutionList ='/complaints_drop_down/Resolution';
  private getResolutionTypeList = '/complaints_drop_down/ResolutionType';
  private getEmailTypeList ='/complaints_drop_down/EmailType';
  private getIdListData = 'https://devservices2.parplatinumcompliance.com';

  constructor(private httpClient: HttpClient,private userFriendlyMsgs: UserFriendlyMsgs) { }

  getCategory(){
    return this.httpClient.get(`${this.url}${this.getCategoryList}`)
    .catch(this.userFriendlyMsgs.errorHandler);
  }

  getTypeOfComplaint(){
    return this.httpClient.get(`${this.url}${this.getTypeOfComplaintList}`)
    .catch(this.userFriendlyMsgs.errorHandler);
  }

  getComplaintSource(){
    return this.httpClient.get(`${this.url}${this.getComplaintSourceList}`)
    .catch(this.userFriendlyMsgs.errorHandler);
  }

  getUsers(){
    return this.httpClient.get(`${this.url}${this.getUsersList}`)
    .catch(this.userFriendlyMsgs.errorHandler);
  }

  getLocationData(vendor_id){
    return this.httpClient.get(this.url + '/vendor/' + vendor_id + '/locations')
    .catch(this.userFriendlyMsgs.errorHandler);
  }

  getRequest(){
    return this.httpClient.get(`${this.url}${this.getRequestList}`)
    .catch(this.userFriendlyMsgs.errorHandler);
  }

  getResolutionData(){
    return this.httpClient.get(`${this.url}${this.getResolutionList}`)
    .catch(this.userFriendlyMsgs.errorHandler);
  }

  getResolutionTypeData(){
    return this.httpClient.get(`${this.url}${this.getResolutionTypeList}`)
    .catch(this.userFriendlyMsgs.errorHandler);
  }

  getEmialTypeList(){
    return this.httpClient.get(`${this.url}${this.getEmailTypeList}`)
    .catch(this.userFriendlyMsgs.errorHandler);
  }

  getIdData(Id){
    return this.httpClient.get( this.url + '/vipr/' +  Id)
    .catch(this.userFriendlyMsgs.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/complaints_drop_down/complaints-drop-down.service.ts